// @ts-nocheck

export const installIntercom = (APP_ID: string) => {
  const w = <any>window;
  const ic = w.Intercom;
  if (typeof ic === 'function') {
    ic('reattach_activator');
    ic('update', w.intercomSettings);
  } else {
    const d = document;
    const i = function () {
      i.c(arguments);
    };
    i.q = [];
    i.c = function (args) {
      i.q.push(args);
    };
    w.Intercom = i;
    const l = function () {
      const s = d.createElement('script');
      s.type = 'text/javascript';
      s.async = true;
      s.src = 'https://widget.intercom.io/widget/' + APP_ID;
      const x = d.getElementsByTagName('script')[0];
      x.parentNode!.insertBefore(s, x);
    };

    l();
  }
};
